import React from 'react';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Box, InputLabel } from '@mui/material';
import StyledPopover from './AddNewValuePopover.style';

import { delay } from 'utils/general';

const OptionsModalBox: React.FC<{
  anchorEl: Element | null;
  inputPattern?: string;
  onClose: () => void;
  onSave: (value: string) => void;
}> = (props) => {
  const [value, setValue] = React.useState('');
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (props.anchorEl) {
      (async () => {
        await delay(100);

        inputRef.current?.focus();
      })()
    }
  }, [props.anchorEl]);

  const handleSaveClick = () => {
    if (!validateInput(value)) {
      return;
    }
    props.onSave(value)
    setValue('');
  }

  const handleEnterKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleSaveClick();
    }
  };

  const handleInputChange = (event: any) => {
    const { value } = event.target;
    if (validateInput(value)) {
      setValue(value);
    }
  };

  const validateInput = (value: string) => {
    if (!props.inputPattern) {
      return true;
    }

    const pattern = new RegExp(props.inputPattern);
    return pattern.test(value) || value === '';
  };

  return (
    <StyledPopover
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={() => {
        props.onClose();
        setValue('');
      }}
      anchorOrigin={{
        vertical: 50,
        horizontal: -200,
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="start" p={1} justifyContent="center">
        <InputLabel>
          Enter value
        </InputLabel>

        <Box display="flex" alignItems="center" justifyContent="center">
          <TextField
            size="small"
            inputRef={inputRef}
            variant="outlined"
            value={value}
            fullWidth
            onChange={handleInputChange}
            onKeyDown={handleEnterKeyDown}
          />

          <Button
            className='btn'
            onClick={handleSaveClick}
          >
            Save
          </Button>
        </Box>
      </Box>
    </StyledPopover >
  );
}

export default OptionsModalBox;
